import React from "react";
import { Card, CardImage, Image, Title, Description, Button } from "./BlogSlider.style";

const BlogCard = ({ blog }) => {
  return (
    <Card>
      <CardImage backgroundImage={blog.background}>
      {/* <Image>
        <img src={blog.image} alt={blog.nambackgrounde} />
      </Image> */}
      {/* <Title>{blog.name}</Title> */}
      {/* <Description>{blog.description}</Description> */}
      </CardImage>
      <Button><a href={blog.link}>Leer Más</a></Button>
    </Card>
  );
};

export default BlogCard;